import { render, staticRenderFns } from "./ActionDownloadCurrent.vue?vue&type=template&id=352f1ad6"
import script from "./ActionDownloadCurrent.vue?vue&type=script&lang=js"
export * from "./ActionDownloadCurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports